<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-btn icon dark @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t('components.CreateUser.title') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark text @click="triggerCreateUser" v-if="editingUser">{{ $t('components.CreateUser.save') }}</v-btn>
        <v-btn dark text @click="triggerCreateUser" v-else>{{ $t('components.CreateUser.create') }}</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-form ref="form" v-model="validForm">
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="4" md="4">
              <v-text-field v-model="firstName" :rules="rules.firstName" :label="$t('components.CreateUser.firstName')" required autofocus></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field v-model="lastName" :rules="rules.lastName" :label="$t('components.CreateUser.lastName')" required autofocus></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" md="4">
              <v-text-field v-model="email1" :disabled="this.editingUser != null" :rules="rules.email1" :label="$t('components.CreateUser.email')" required autofocus></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field v-model="email2" :disabled="this.editingUser != null" :rules="rules.email2" :label="$t('components.CreateUser.repeatEmail')" required autofocus></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="!this.editingUser">
            <v-col cols="12" sm="4" md="4">
              <v-switch v-model="setPasswordManually" :label="$t('components.CreateUser.setPasswordManually')"></v-switch>
            </v-col>
          </v-row>
          <v-row v-if="!this.editingUser && this.setPasswordManually">
            <v-col cols="12" sm="4" md="4">
              <v-text-field type="password" v-model="password1" :rules="rules.password1" :label="$t('components.CreateUser.password')" autofocus></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field type="password" v-model="password2" :rules="rules.password2" :label="$t('components.CreateUser.repeatPassword')" autofocus></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" md="4">
              <v-text-field v-model="phoneNumber" :rules="rules.phoneNumber" :label="$t('components.CreateUser.phoneNumber')" autofocus></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="3" md="3">
              <v-select v-model="isAdmin" :disabled="this.domain != 'noisegrasp'" :items="booleanItems" label="isAdmin" item-text="name" item-value="id"></v-select>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-select v-model="isManager" :items="booleanItems" label="isManager" item-text="name" item-value="id"></v-select>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-select v-model="isScientist" :items="booleanItems" label="isScientist" item-text="name" item-value="id"></v-select>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-select v-model="isSupervisor" :items="booleanItems" label="isSupervisor" item-text="name" item-value="id"></v-select>
            </v-col>
            <v-col cols="12" sm="3" md="3">
              <v-select v-model="isCustomizer" :items="booleanItems" label="isCustomizer" item-text="name" item-value="id"></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="4" md="4">
              <v-select v-model="domain" :disabled="this.editingUser != null" :items="[{ name: 'noisegrasp', id: 'noisegrasp' }, { name: 'publicis', id: 'publicis' }]" :label="$t('components.CreateUser.domain')" item-text="name" item-value="id"></v-select>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  components: {},
  data () {
    return {
      validForm: true,
      firstName: '',
      lastName: '',
      email1: '',
      email2: '',
      password1: '',
      password2: '',
      isAdmin: false,
      isManager: false,
      isScientist: false,
      isSupervisor: false,
      isCustomizer: false,
      id: null,
      domain: 'noisegrasp',
      phoneNumber: '',
      setPasswordManually: false
    }
  },
  methods: {
    ...mapActions('admin', [
      'createUser',
      'editUser'
    ]),
    closeDialog () {
      this.$emit('close-dialog')
    },
    validateForm () {
      return this.$refs.form.validate()
    },
    triggerCreateUser () {
      if (this.editingUser && this.firstName.length > 0 && this.lastName.length > 0) {
        this.editUser({
          id: this.id,
          editedBy: this.createdBy,
          firstName: this.firstName,
          lastName: this.lastName,
          isAdmin: this.domain === 'noisegrasp' ? this.isAdmin : false,
          isManager: this.isManager,
          isScientist: this.isScientist,
          isSupervisor: this.isSupervisor,
          isCustomizer: this.isCustomizer,
          phoneNumber: this.phoneNumber ? this.phoneNumber : null
        })
        this.closeDialog()
      } else {
        if (this.validateForm()) {
          this.createUser({
            createdBy: this.createdBy,
            firstName: this.firstName,
            lastName: this.lastName,
            email: this.email1,
            password: this.password1,
            isAdmin: this.domain === 'noisegrasp' ? this.isAdmin : false,
            isManager: this.isManager,
            isScientist: this.isScientist,
            isSupervisor: this.isSupervisor,
            isCustomizer: this.isCustomizer,
            domain: this.domain,
            phoneNumber: this.phoneNumber
          })
          this.closeDialog()
        }
      }
    }
  },
  computed: {
    re () {
      return new RegExp('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^*-]).{12,}$')
    },
    booleanItems () {
      return [
        { name: this.$t('components.CreateUser.true'), id: true },
        { name: this.$t('components.CreateUser.false'), id: false }
      ]
    },
    rules () {
      return {
        firstName: [
          v => !!v || this.$t('components.CreateUser.firstNameRequired')
        ],
        lastName: [
          v => !!v || this.$t('components.CreateUser.lastNameRequired')
        ],
        email1: [
          v => !!v || this.$t('components.CreateUser.emailRequired'),
          v => /.+@.+/.test(v) || this.$t('components.CreateUser.emailInvalid'),
          v => !this.existingUsers.includes(this.email1) || this.$t('components.CreateUser.emailExists')
        ],
        email2: [
          v => !!v || this.$t('components.CreateUser.emailRequired'),
          v => v === this.email1 || this.$t('components.CreateUser.emailsMustMatch')
        ],
        password1: [
          v => (this.re.test(v) || !this.setPasswordManually) || this.$t('components.CreateUser.passwordRequirements')
        ],
        password2: [
          v => v === this.password1 || this.$t('components.CreateUser.passwordsMustMatch')
        ],
        phoneNumber: [
          v => (!this.phoneNumber || this.phoneNumber.length === 0 || this.phoneNumber.startsWith('+')) || this.$t('components.CreateUser.phoneNumberInvalid')
        ]
      }
    }
  },
  props: {
    createdBy: {
      type: String,
      required: true
    },
    existingUsers: {
      type: Array,
      required: false,
      default: function () {
        return []
      }
    },
    editingUser: {
      type: Object,
      required: false
    }
  },
  watch: {
    editingUser: {
      immediate: true,
      handler: function () {
        if (this.editingUser) {
          var user = this.editingUser
          this.email1 = user.email
          this.email2 = user.email
          this.firstName = user.firstName
          this.lastName = user.lastName
          this.isAdmin = 'isAdmin' in user ? user.isAdmin : false
          this.isManager = 'isManager' in user ? user.isManager : false
          this.isScientist = 'isScientist' in user ? user.isScientist : false
          this.isSupervisor = 'isSupervisor' in user ? user.isSupervisor : false
          this.isCustomizer = 'isCustomizer' in user ? user.isCustomizer : false
          this.id = user.id
          this.domain = user.domain
          this.phoneNumber = user.phoneNumber || ''
        }
      }
    },
    domain: function (newValue) {
      if (newValue !== 'noisegrasp') {
        this.isAdmin = false
      }
    }
  }
}
</script>
